// extracted by mini-css-extract-plugin
export var drawerPaper = "_2e-0";
export var itemCard = "_2e-1";
export var itemImage = "_2e-2";